import script from "./VisualizationOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./VisualizationOverlay.vue?vue&type=script&lang=ts&setup=true"

import "./VisualizationOverlay.vue?vue&type=style&index=0&id=9545a25a&scoped=true&lang=less"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9545a25a"]])

export default __exports__